import { Component, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { VehicleChargingFigureService } from 'src/app/_services/vehicle-charging-figure.service';
import { createPlotlyChart } from 'src/app/_shared/plotlyConfig';

@Component({
  selector: 'app-charged-energy-over-time-chart',
  templateUrl: './charged-energy-over-time-chart.component.html',
  styleUrls: ['./charged-energy-over-time-chart.component.scss']
})
export class ChargedEnergyOverTimeChartComponent implements OnChanges, OnDestroy {
  private readonly unsubscribe$ = new Subject<void>();
  @Input() selectedVehicles!: any[];
  deviceSerialNumber!: any[];
  errorMessage: boolean = false;
  dataLoading: boolean = false;
  numberMonths: number = 0;
  private colorMap: {[key:string]:string}={};

  constructor(
    private readonly vehicleChargingFigureService: VehicleChargingFigureService
  ) {}

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.dataLoading = true;
    this.errorMessage = false;
    this.deviceSerialNumber = this.selectedVehicles.map(vehicle => vehicle.batteryIdentifier);
    this.vehicleChargingFigureService.getChargedEnergyTime(this.deviceSerialNumber).pipe(takeUntil(this.unsubscribe$)).subscribe({
      next: (data: any) => {
        this.plotchargedEnergyOverTimeChart(data);
      },
      error: (error) => {
        console.error('Error fetching Charged Energy Over Time data:', error);
        this.dataLoading = false;
        this.errorMessage = true;
      },
      complete: () => {
        this.dataLoading = false;
      }
    });
  }
  

  plotchargedEnergyOverTimeChart(data: any): void {
    this.initializeColorMap();
    const plotData = Object.keys(data).flatMap((deviceSerialNumberId: string) => {
      const deviceDataArray = this.sortByTime(data[deviceSerialNumberId]);
      const vehicle = this.selectedVehicles.find(vehicle => vehicle.batteryIdentifier === deviceSerialNumberId);

      const monthLabels = deviceDataArray.map((dataObject: any) => {
        const formattedDate = new Date(dataObject.month).toLocaleString('default', { month: 'short', year: 'numeric' });
        return formattedDate;
      });

      this.numberMonths = monthLabels.length
  
      const energies = deviceDataArray.map((dataObject: any) => dataObject.chargedEnergy);
  
      return {
        x: monthLabels,
        y: energies,
        type: 'bar',
        name: vehicle ? vehicle.name : deviceSerialNumberId,
        marker: {
          color: this.colorMap[deviceSerialNumberId]
        }
      };
    });
  
    const layout = {
      title: 'Charged Energy over Time',
      font: {
        family: 'boschsans, Helvetica Neue, Helvetica, Arial, sans-serif',
        size: 13,
      },
      barmode: 'group',
      xaxis: {
        title: 'Time [Months]',
      },
      yaxis: {
        title: 'Energy [kWh]'
      },
      showlegend: true,
      legend: {
        orientation: 'h',
        y: -0.3,
        xanchor: 'center',
        x: 0.5,
        font: {
          family: 'boschsans, Helvetica Neue, Helvetica, Arial, sans-serif',
          size: 13,
        },
      }
    };
  
    createPlotlyChart('charged-energy-over-time', plotData, layout);
  }

  sortByTime(data: any[]): any[] {
    return data.slice().sort((a, b) => new Date(a.month).getTime() - new Date(b.month).getTime());
  }

  initializeColorMap(): void {
    const colors = ['#007BC0', '#18837E','#9E2896'];
    this.selectedVehicles.forEach((vehicle, index) => {
      this.colorMap[vehicle.batteryIdentifier] = colors[index % colors.length];
    });
  }

}
